export const whyChooseItems = [
  {
    title: 'Child-Centred Learning',
    description:
      'Every child is respected as a unique individual with their own interests, pace, and potential.',
    color: '#2d6a4f',
    icon: 'children',
  },
  {
    title: 'Hands-On Discovery',
    description:
      'Children learn by doing — exploring real materials that engage all the senses.',
    color: '#f4a825',
    icon: 'hands',
  },
  {
    title: 'Prepared for Life',
    description:
      'Practical skills, independence, and confidence that extend far beyond the classroom.',
    color: '#e07a9a',
    icon: 'heart',
  },
  {
    title: 'Whole Child Development',
    description:
      'We nurture intellectual, social, emotional, and physical growth in harmony.',
    color: '#4ea8de',
    icon: 'globe',
  },
];
